// ModelContext.js
import { createContext, useContext, useState } from "react";

const ModelContext = createContext();

export const ModelOpenProvider = ({ children }) => {
  const [cartOpen, setCartOpen] = useState(0);
  const [addressDrawer, setAddressDrawer] = useState(false);
  const [bvnDrawer, setBvnDrawer] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [searchDrawer, setSearchDrawer] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [location, setLocation] = useState({
    address: "Detecting...",
    loading: false,
    lat: null,
    lng: null
  });

  return (
    <ModelContext.Provider 
      value={{ cartOpen, setCartOpen, addressDrawer, setAddressDrawer, bvnDrawer, setBvnDrawer, orderId, setOrderId, searchDrawer, setSearchDrawer, loginModal, setLoginModal, location, setLocation }}>
      {children}
    </ModelContext.Provider>
  );
};

// custom hook for easy usage
export const useDrawerOpenFun = () => useContext(ModelContext);
